var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ogrod_wloski"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.36,97.7v-.88c.86-.67,1.33-1.76,1.33-1.76,0,0-.57-.47-1.33-.74v-3.83c1.17.27,2.42-.37,2.42-.37,0,0-.41-1.96-1.69-2.64-.25-.13-.49-.23-.74-.3v-1.83c.49-.06,1.05-.27,1.58-.64,1.21-.82,1.42-2.82,1.42-2.82,0,0-1.74-.66-2.95.16-.02.01-.03.03-.05.04v-2.87h-3.79c-.07-1.15-.69-2.16-.69-2.16,0,0-1.68.71-2.13,2.16h-.66c-.17-.94-.63-1.7-.63-1.7,0,0-1.33.56-1.94,1.7h-17.81c.36-1.34-.32-2.87-.32-2.87,0,0-1.79.47-2.4,1.88-.14.33-.24.67-.31.99h-.66c-.9-1.13-2.64-1.18-2.64-1.18,0,0-.11.51-.11,1.18h-14.16c-.12-.75-.37-1.34-.37-1.34,0,0-1.31.35-2.07,1.34h-1.06c-.05-.97-.42-1.8-.42-1.8,0,0-1.71.46-2.35,1.8h-5.05c-.12-.46-.26-.78-.26-.78,0,0-.79.22-1.5.78h-5.02c-.7-.7-1.59-1.02-1.59-1.02,0,0-.22.42-.39,1.02h-6.74c-.55-1.39-2.24-1.98-2.24-1.98,0,0-.49.92-.56,1.98h-2.22c-.04-.37-.12-.75-.26-1.14-.51-1.45-2.27-2.05-2.27-2.05,0,0-.93,1.74-.41,3.18.18.52.43.96.71,1.31v1.71c-1.11-.07-2.18.57-2.18.57,0,0,.36,1.27,1.21,2.06-1.02.71-1.49,2.16-1.49,2.16,0,0,1.24.84,2.46.66v3.93c-.93.73-1.36,2.05-1.36,2.05,0,0,.59.4,1.36.59v1.8c-.71.11-1.26.39-1.26.39,0,0,.31,1.52,1.26,2.35v4.43h3.19c-.41.83-.51,1.69-.51,1.69,0,0,1.74.66,2.95-.16.64-.44,1.11-.99,1.36-1.53h.5c.06.13.13.26.21.39.78,1.29,2.62,1.48,2.62,1.48,0,0,.26-.89.17-1.87h9.84s.02.03.03.05c.78,1.29,2.62,1.48,2.62,1.48,0,0,.2-.7.19-1.53h4.21c-.01.69.1,1.24.1,1.24,0,0,1.82-.04,2.7-1.24h.6c-.27,1.09-.02,2.23-.02,2.23,0,0,1.85-.03,2.72-1.26.22-.32.4-.64.54-.97h9.52c.05.09.1.18.17.27.86,1.24,2.7,1.3,2.7,1.3,0,0,.17-.72.1-1.57h14.64s.04.07.06.1c.86,1.24,2.7,1.3,2.7,1.3,0,0,.14-.63.11-1.4h4.28c-.49.88-.61,1.87-.61,1.87,0,0,1.74.66,2.95-.16.71-.48,1.22-1.12,1.44-1.71h.03c.06.7.64,1.57,1.55,2.18,1.21.82,2.95.16,2.95.16,0,0-.16-1.4-.93-2.34h6.63v-2.37c.1-.02.2-.03.3-.06,1.38-.37,2.16-2.2,2.16-2.2,0,0-1.2-.98-2.45-.9Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.22,77.17c.16,0,.31,0,.46,0l.82-.91c-.7-.17-.82-.46-.82-.46,0,0,.62-.09,1.35-.13l.35-.39c-.61-.02-1.05-.08-1.05-.08,0,0,.58-.33,1.58-.5l.82-.91h2.75c-.21-.17-.16-.34-.16-.34,0,0,1.6-.13,2.5.03.48.09.8.2.94.31h.43c.07-.03.15-.05.24-.08.86-.26,2.46-.29,2.46-.29,0,0,.1.18-.1.37h8.49s.02,0,.03-.01c.79-.26,2.38-.3,2.38-.3,0,0,.12.14.04.31h3.63c.03-.14.16-.25.16-.25,0,0,1.56,0,2.25.25h.52c-.18-.22.08-.44.08-.44,0,0,1.57,0,2.28.25.18.06.32.13.43.19h8.21s.09-.04.14-.05c.72-.25,2.3-.26,2.3-.26,0,0,.16.14.12.31h12.63s.03-.01.04-.02c.63-.25,2.2-.26,2.2-.26,0,0,.18.13.23.28h3.69c-.52-.18-.74-.37-.74-.37,0,0,1.41-.13,2.54.03.67.1,1.19.22,1.45.34h.02c-.04-.14.34-.31,1.03-.43.91-.16,2.49-.03,2.49-.03,0,0,.07.28-.44.46h5.72l.43.48c.09,0,.18,0,.27.01,1.28.08,2.31.46,2.31.46,0,0-.87.21-2,.19l.17.19c.89.14,1.53.38,1.53.38,0,0-.42.1-1.05.16l.76.86c1.02-.06,2.96,2.2,2.96,2.2",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.79,85.02c-.72-.93-.84-1.94,0-3.06,1.28.44,2.02,1.12,2.19,2.04",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,98.26c-.79,0-.79,1.32-.7,2.81,1.45-.07,2.33-.65,2.58-1.79l.94,1.4,1.29-1.02",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "89.99 83.32 91.86 82.04 92.33 83.45 94.09 82.81 95.15 83.96",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "65.13 98.64 66.53 100.17 67.71 99.4 69 99.4 70.75 98.51",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.17,88.55c-1.01-.33-1.14.36-1.29,1.02l.94,1.4-.59,1.28.59.38",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.61,97.7v-.88c-.86-.67-1.33-1.76-1.33-1.76,0,0,.57-.47,1.33-.74v-3.83c-1.17.27-2.42-.37-2.42-.37,0,0,.41-1.96,1.69-2.64.25-.13.49-.23.74-.3v-1.83c-.49-.06-1.05-.27-1.58-.64-1.21-.82-1.42-2.82-1.42-2.82,0,0,1.74-.66,2.95.16.02.01.03.03.05.04v-2.87h3.79c.07-1.15.69-2.16.69-2.16,0,0,1.68.71,2.13,2.16h.66c.17-.94.63-1.7.63-1.7,0,0,1.33.56,1.94,1.7h17.81c-.36-1.34.32-2.87.32-2.87,0,0,1.79.47,2.4,1.88.14.33.24.67.31.99h.66c.9-1.13,2.64-1.18,2.64-1.18,0,0,.11.51.11,1.18h14.16c.12-.75.37-1.34.37-1.34,0,0,1.31.35,2.07,1.34h1.06c.05-.97.42-1.8.42-1.8,0,0,1.71.46,2.35,1.8h5.05c.12-.46.26-.78.26-.78,0,0,.79.22,1.5.78h5.02c.7-.7,1.59-1.02,1.59-1.02,0,0,.22.42.39,1.02h6.74c.55-1.39,2.24-1.98,2.24-1.98,0,0,.49.92.56,1.98h2.22c.04-.37.12-.75.26-1.14.51-1.45,2.27-2.05,2.27-2.05,0,0,.93,1.74.41,3.18-.18.52-.43.96-.71,1.31v1.71c1.11-.07,2.18.57,2.18.57,0,0-.36,1.27-1.21,2.06,1.02.71,1.49,2.16,1.49,2.16,0,0-1.24.84-2.46.66v3.93c.93.73,1.36,2.05,1.36,2.05,0,0-.59.4-1.36.59v1.8c.71.11,1.26.39,1.26.39,0,0-.31,1.52-1.26,2.35v4.43h-3.19c.41.83.51,1.69.51,1.69,0,0-1.74.66-2.95-.16-.64-.44-1.11-.99-1.36-1.53h-.5c-.06.13-.13.26-.21.39-.78,1.29-2.62,1.48-2.62,1.48,0,0-.26-.89-.17-1.87h-9.84s-.02.03-.03.05c-.78,1.29-2.62,1.48-2.62,1.48,0,0-.2-.7-.19-1.53h-4.21c.01.69-.1,1.24-.1,1.24,0,0-1.82-.04-2.7-1.24h-.6c.27,1.09.02,2.23.02,2.23,0,0-1.85-.03-2.72-1.26-.22-.32-.4-.64-.54-.97h-9.52c-.05.09-.1.18-.17.27-.86,1.24-2.7,1.3-2.7,1.3,0,0-.17-.72-.1-1.57h-14.64s-.04.07-.06.1c-.86,1.24-2.7,1.3-2.7,1.3,0,0-.14-.63-.11-1.4h-4.28c.49.88.61,1.87.61,1.87,0,0-1.74.66-2.95-.16-.71-.48-1.22-1.12-1.44-1.71h-.03c-.06.7-.64,1.57-1.55,2.18-1.21.82-2.95.16-2.95.16,0,0,.16-1.4.93-2.34h-6.63v-2.37c-.1-.02-.2-.03-.3-.06-1.38-.37-2.16-2.2-2.16-2.2,0,0,1.2-.98,2.45-.9Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74,77.17c-.16,0-.31,0-.46,0l-.82-.91c.7-.17.82-.46.82-.46,0,0-.62-.09-1.35-.13l-.35-.39c.61-.02,1.05-.08,1.05-.08,0,0-.58-.33-1.58-.5l-.82-.91h-2.75c.21-.17.16-.34.16-.34,0,0-1.6-.13-2.5.03-.48.09-.8.2-.94.31h-.43c-.07-.03-.15-.05-.24-.08-.86-.26-2.46-.29-2.46-.29,0,0-.1.18.1.37h-8.49s-.02,0-.03-.01c-.79-.26-2.38-.3-2.38-.3,0,0-.12.14-.04.31h-3.63c-.03-.14-.16-.25-.16-.25,0,0-1.56,0-2.25.25h-.52c.18-.22-.08-.44-.08-.44,0,0-1.57,0-2.28.25-.18.06-.32.13-.43.19h-8.21s-.09-.04-.14-.05c-.72-.25-2.3-.26-2.3-.26,0,0-.16.14-.12.31h-12.63s-.03-.01-.04-.02c-.63-.25-2.2-.26-2.2-.26,0,0-.18.13-.23.28h-3.69c.52-.18.74-.37.74-.37,0,0-1.41-.13-2.54.03-.67.1-1.19.22-1.45.34h-.02c.04-.14-.34-.31-1.03-.43-.91-.16-2.49-.03-2.49-.03,0,0-.07.28.44.46h-5.72s-.43.48-.43.48c-.09,0-.18,0-.27.01-1.28.08-2.31.46-2.31.46,0,0,.87.21,2,.19l-.17.19c-.89.14-1.53.38-1.53.38,0,0,.42.1,1.05.16l-.76.86c-1.02-.06-2.96,2.2-2.96,2.2",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.18,85.02c.72-.93.84-1.94,0-3.06-1.28.44-2.02,1.12-2.19,2.04",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.77,98.26c.79,0,.79,1.32.7,2.81-1.45-.07-2.33-.65-2.58-1.79l-.94,1.4-1.29-1.02",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.98 83.32 159.1 82.04 158.63 83.45 156.87 82.81 155.82 83.96",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "185.84 98.64 184.43 100.17 183.26 99.4 181.97 99.4 180.21 98.51",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.8,88.55c1.01-.33,1.14.36,1.29,1.02l-.94,1.4.59,1.28-.59.38",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.65,38.77c0-6.84-3.41-12.38-7.62-12.38-.23,0-.45.02-.67.05.05-.65.08-1.3.08-1.97,0-10.93-7.19-19.79-16.07-19.79s-16.07,8.86-16.07,19.79c0,1.99.24,3.91.69,5.72-4.25,1.19-7.49,7.2-7.49,14.45,0,8.11,4.04,14.68,9.03,14.68.78,0,1.53-.18,2.25-.48,2.84,5.33,7.96,8.9,13.81,8.9,8.47,0,15.4-7.44,16.11-16.91,3.4-1.25,5.93-6.17,5.93-12.07Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "200.45 73.54 200.45 46.81 191.57 38.13 184.54 40.43",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "206.12 20 202.36 27.4 204.71 42.72 200.45 46.81",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.78,
    y1: 17.96,
    x2: 204,
    y2: 23.32,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.49,
    y1: 57.79,
    x2: 207.05,
    y2: 52.94,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.57,
    y1: 38.13,
    x2: 189.23,
    y2: 34.3,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.53,38.77c0-6.84,3.41-12.38,7.62-12.38.23,0,.45.02.67.05-.05-.65-.08-1.3-.08-1.97,0-10.93,7.19-19.79,16.07-19.79s16.07,8.86,16.07,19.79c0,1.99-.24,3.91-.69,5.72,4.25,1.19,7.49,7.2,7.49,14.45,0,8.11-4.04,14.68-9.03,14.68-.78,0-1.53-.18-2.25-.48-2.84,5.33-7.96,8.9-13.81,8.9-8.47,0-15.4-7.44-16.11-16.91-3.4-1.25-5.93-6.17-5.93-12.07Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45.73 73.54 45.73 46.81 54.6 38.13 61.64 40.43",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.06 20 43.82 27.4 41.47 42.72 45.73 46.81",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.39,
    y1: 17.96,
    x2: 42.17,
    y2: 23.32,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.69,
    y1: 57.79,
    x2: 39.12,
    y2: 52.94,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.6,
    y1: 38.13,
    x2: 56.95,
    y2: 34.3,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.24,46.15s-.12.22-.2.53h-2.94c-.04-.59-.36-1.12-.36-1.12,0,0-.37.16-.69.48-.33-.27-.67-.38-.67-.38,0,0-.13.25-.21.59-.1-.26-.2-.44-.2-.44,0,0-.69.29-1,.88h-.02c-.02-.19-.06-.39-.14-.59-.27-.75-1.18-1.06-1.18-1.06,0,0-.48.9-.21,1.65,0,0,0,0,0,0h-7.68c.19-.69-.16-1.49-.16-1.49,0,0-.93.25-1.24.97-.07.17-.13.35-.16.51h-.34c-.46-.59-1.37-.61-1.37-.61,0,0-.06.27-.06.61h-7.33c-.06-.39-.19-.69-.19-.69,0,0-.68.18-1.07.69h-.55c-.03-.5-.22-.93-.22-.93,0,0-.89.24-1.22.93h-2.62c-.06-.24-.13-.4-.13-.4,0,0-.41.11-.78.4h-2.6c-.36-.36-.83-.53-.83-.53,0,0-.12.22-.2.53h-2.94c-.04-.59-.36-1.12-.36-1.12,0,0-.37.16-.69.48-.33-.27-.67-.38-.67-.38,0,0-.13.25-.21.59-.1-.26-.2-.44-.2-.44,0,0-.69.29-1,.88h-.02c-.02-.19-.06-.39-.14-.59-.27-.75-1.18-1.06-1.18-1.06,0,0-.48.9-.21,1.65,0,0,0,0,0,0h-7.68c.19-.69-.16-1.49-.16-1.49,0,0-.93.25-1.24.97-.07.17-.13.35-.16.51h-.34c-.46-.59-1.37-.61-1.37-.61,0,0-.06.27-.06.61h-7.33c-.06-.39-.19-.69-.19-.69,0,0-.68.18-1.07.69h-.55c-.03-.5-.22-.93-.22-.93,0,0-.89.24-1.22.93h-2.62c-.06-.24-.13-.4-.13-.4,0,0-.41.11-.78.4h-2.6c-.36-.36-.83-.53-.83-.53,0,0-.12.22-.2.53h-2.94c-.04-.59-.36-1.12-.36-1.12,0,0-.37.16-.69.48-.33-.27-.67-.38-.67-.38,0,0-.13.25-.21.59-.1-.26-.2-.44-.2-.44,0,0-.69.29-1,.88h-.02c-.02-.19-.06-.39-.14-.59-.27-.75-1.18-1.06-1.18-1.06,0,0-.48.9-.21,1.65,0,0,0,0,0,0h-7.68c.19-.69-.16-1.49-.16-1.49,0,0-.93.25-1.24.97-.07.17-.13.35-.16.51h-.34c-.46-.59-1.37-.61-1.37-.61,0,0-.06.27-.06.61h-7.33c-.06-.39-.19-.69-.19-.69,0,0-.68.18-1.07.69h-.55c-.03-.5-.22-.93-.22-.93,0,0-.89.24-1.22.93h-2.62c-.06-.24-.13-.4-.13-.4",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.17,59.1h5.1s0,.02.01.03c.41.67,1.36.77,1.36.77,0,0,.1-.36.1-.79h2.18c0,.36.05.64.05.64,0,0,.94-.02,1.4-.64h.31c-.14.56-.01,1.15-.01,1.15,0,0,.96-.02,1.41-.65.12-.16.21-.33.28-.5h4.93s.05.09.09.14c.44.64,1.4.67,1.4.67,0,0,.09-.38.05-.81h7.58s.02.03.03.05c.44.64,1.4.67,1.4.67,0,0,.07-.33.06-.72h2.21c-.25.45-.31.97-.31.97,0,0,.9.34,1.53-.08.37-.25.63-.58.74-.89h.01c.02.25.17.53.41.79,0,.05-.01.09-.01.09,0,0,.06.02.15.05.08.07.16.15.26.21.63.43,1.53.08,1.53.08,0,0-.03-.29-.16-.63.2-.18.37-.38.46-.58h.26c.03.07.07.14.11.2.41.67,1.36.77,1.36.77,0,0,.13-.46.09-.97h5.1s0,.02.01.03c.41.67,1.36.77,1.36.77,0,0,.1-.36.1-.79h2.18c0,.36.05.64.05.64,0,0,.94-.02,1.4-.64h.31c-.14.56-.01,1.15-.01,1.15,0,0,.96-.02,1.41-.65.12-.16.21-.33.28-.5h4.93s.05.09.09.14c.44.64,1.4.67,1.4.67,0,0,.09-.38.05-.81h7.58s.02.03.03.05c.44.64,1.4.67,1.4.67,0,0,.07-.33.06-.72h2.21c-.25.45-.31.97-.31.97,0,0,.9.34,1.53-.08.37-.25.63-.58.74-.89h.01c.02.25.17.53.41.79,0,.05-.01.09-.01.09,0,0,.06.02.15.05.08.07.16.15.26.21.63.43,1.53.08,1.53.08,0,0-.03-.29-.16-.63.2-.18.37-.38.46-.58h.26c.03.07.07.14.11.2.41.67,1.36.77,1.36.77,0,0,.13-.46.09-.97h5.1s0,.02.01.03c.41.67,1.36.77,1.36.77,0,0,.1-.36.1-.79h2.18c0,.36.05.64.05.64,0,0,.94-.02,1.4-.64h.31c-.14.56-.01,1.15-.01,1.15,0,0,.96-.02,1.41-.65.12-.16.21-.33.28-.5h4.93s.05.09.09.14c.44.64,1.4.67,1.4.67,0,0,.09-.38.05-.81h7.58s.02.03.03.05c.44.64,1.4.67,1.4.67,0,0,.07-.33.06-.72h2.21c-.25.45-.31.97-.31.97,0,0,.9.34,1.53-.08.37-.25.63-.58.74-.89h.01c.02.25.17.53.41.79,0,.05-.01.09-.01.09,0,0,.06.02.15.05.08.07.16.15.26.21.63.43,1.53.08,1.53.08,0,0-.03-.29-.16-.63.2-.18.37-.38.46-.58h.26c.03.07.07.14.11.2.41.67,1.36.77,1.36.77,0,0,.13-.46.09-.97h5.1s0,.02.01.03c.41.67,1.36.77,1.36.77,0,0,.1-.36.1-.79h2.18",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.78,43.85c.41-.13,1.23-.15,1.23-.15,0,0,.06.07.02.16h1.88c.02-.07.08-.13.08-.13,0,0,.81,0,1.17.13h.27c-.09-.11.04-.23.04-.23,0,0,.81,0,1.18.13.09.03.17.07.22.1h4.25s.05-.02.07-.03c.37-.13,1.19-.13,1.19-.13,0,0,.08.07.06.16h6.54s.01,0,.02-.01c.33-.13,1.14-.13,1.14-.13,0,0,.09.06.12.14h1.91c-.27-.09-.38-.19-.38-.19,0,0,.73-.07,1.32.02.35.05.62.12.75.18h.01c-.02-.07.18-.16.54-.22.47-.08,1.29-.02,1.29-.02,0,0,.04.14-.23.24h2.96l.22.25s.09,0,.14,0c.66.04,1.2.24,1.2.24,0,0-.45.11-1.03.1l.09.1c.46.07.79.2.79.2,0,0-.22.05-.54.08l.4.45c.53-.03,1.53,1.14,1.53,1.14",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "94.44 48.79 95.41 48.13 95.66 48.86 96.57 48.53 97.11 49.12",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.57 56.72 82.3 57.52 82.9 57.12 83.57 57.12 84.48 56.66",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.22,45.61c.08,0,.16,0,.24,0l.42-.47c-.36-.09-.43-.24-.43-.24,0,0,.32-.05.7-.07l.18-.2c-.32-.01-.55-.04-.55-.04,0,0,.3-.17.82-.26l.42-.47h1.42c-.11-.09-.08-.17-.08-.17,0,0,.83-.07,1.29.02.25.04.42.1.48.16h.22s.08-.03.12-.04c.45-.13,1.27-.15,1.27-.15,0,0,.05.09-.05.19h4.4s0,0,.01,0c.41-.13,1.23-.15,1.23-.15,0,0,.06.07.02.16h1.88c.02-.07.08-.13.08-.13,0,0,.81,0,1.17.13h.27c-.09-.11.04-.23.04-.23,0,0,.81,0,1.18.13.09.03.17.07.22.1h4.25s.05-.02.07-.03c.37-.13,1.19-.13,1.19-.13,0,0,.08.07.06.16h6.54s.01,0,.02-.01c.33-.13,1.14-.13,1.14-.13,0,0,.09.06.12.14h1.91c-.27-.09-.38-.19-.38-.19,0,0,.73-.07,1.32.02.35.05.62.12.75.18h.01c-.02-.07.18-.16.54-.22.47-.08,1.29-.02,1.29-.02,0,0,.04.14-.23.24h2.96l.22.25s.09,0,.14,0c.66.04,1.2.24,1.2.24,0,0-.45.11-1.03.1l.09.1c.46.07.79.2.79.2,0,0-.22.05-.54.08l.4.45c.53-.03,1.53,1.14,1.53,1.14",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.03,49.67c-.37-.48-.43-1,0-1.59.66.23,1.05.58,1.13,1.06",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,56.52c-.41,0-.41.69-.36,1.45.75-.04,1.21-.34,1.34-.93l.49.73.67-.53",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "130.79 48.79 131.77 48.13 132.01 48.86 132.92 48.53 133.47 49.12",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "117.92 56.72 118.65 57.52 119.26 57.12 119.92 57.12 120.84 56.66",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,51.5c-.52-.17-.59.19-.67.53l.49.73-.3.66.3.2",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.58,45.61c.08,0,.16,0,.24,0l.42-.47c-.36-.09-.43-.24-.43-.24,0,0,.32-.05.7-.07l.18-.2c-.32-.01-.55-.04-.55-.04,0,0,.3-.17.82-.26l.42-.47h1.42c-.11-.09-.08-.17-.08-.17,0,0,.83-.07,1.29.02.25.04.42.1.48.16h.22s.08-.03.12-.04c.45-.13,1.27-.15,1.27-.15,0,0,.05.09-.05.19h4.4s0,0,.01,0c.41-.13,1.23-.15,1.23-.15,0,0,.06.07.02.16h1.88c.02-.07.08-.13.08-.13,0,0,.81,0,1.17.13h.27c-.09-.11.04-.23.04-.23,0,0,.81,0,1.18.13.09.03.17.07.22.1h4.25s.05-.02.07-.03c.37-.13,1.19-.13,1.19-.13,0,0,.08.07.06.16h6.54s.01,0,.02-.01c.33-.13,1.14-.13,1.14-.13,0,0,.09.06.12.14h1.91c-.27-.09-.38-.19-.38-.19,0,0,.73-.07,1.32.02.35.05.62.12.75.18h.01c-.02-.07.18-.16.54-.22.47-.08,1.29-.02,1.29-.02,0,0,.04.14-.23.24h2.96l.22.25s.09,0,.14,0c.66.04,1.2.24,1.2.24,0,0-.45.11-1.03.1l.09.1c.46.07.79.2.79.2,0,0-.22.05-.54.08l.4.45c.53-.03,1.53,1.14,1.53,1.14",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.39,49.67c-.37-.48-.43-1,0-1.59.66.23,1.05.58,1.13,1.06",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.08,56.52c-.41,0-.41.69-.36,1.45.75-.04,1.21-.34,1.34-.93l.49.73.67-.53",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "167.15 48.79 168.12 48.13 168.36 48.86 169.27 48.53 169.82 49.12",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "154.27 56.72 155 57.52 155.61 57.12 156.28 57.12 157.19 56.66",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.24,51.5c-.52-.17-.59.19-.67.53l.49.73-.3.66.3.2",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.75,43.86h1.42c-.11-.09-.08-.17-.08-.17,0,0,.83-.07,1.29.02.25.04.42.1.48.16h.22s.08-.03.12-.04c.45-.13,1.27-.15,1.27-.15",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.74,49.67c-.37-.48-.43-1,0-1.59.66.23,1.05.58,1.13,1.06",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.44,56.52c-.41,0-.41.69-.36,1.45.75-.04,1.21-.34,1.34-.93l.49.73.67-.53",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,51.5c-.52-.17-.59.19-.67.53l.49.73-.3.66.3.2",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,45.77h2.13c.37-.37.84-.54.84-.54,0,0,.12.22.21.54h3.55c.29-.73,1.18-1.04,1.18-1.04,0,0,.26.49.29,1.04h1.17c.02-.19.06-.4.14-.6.27-.76,1.2-1.08,1.2-1.08,0,0,.49.91.22,1.68-.1.27-.23.51-.37.69v.9c.58-.04,1.15.3,1.15.3,0,0-.19.67-.64,1.08.54.37.78,1.13.78,1.13,0,0-.65.44-1.29.35v2.07c.49.39.72,1.08.72,1.08,0,0-.31.21-.72.31v.95c.37.06.67.2.67.2,0,0-.17.8-.67,1.24v2.33h-1.68c.22.43.27.89.27.89,0,0-.92.35-1.55-.08-.34-.23-.59-.52-.72-.81h-.26c-.03.07-.07.14-.11.21-.41.68-1.38.78-1.38.78,0,0-.13-.47-.09-.99h-5.18s0,.02-.01.03c-.41.68-1.38.78-1.38.78,0,0-.11-.37-.1-.81h-2.21c0,.36-.05.65-.05.65,0,0-.96-.02-1.42-.65h-.32",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.04,44.69c-.08,0-.16,0-.24,0l-.43-.48c.37-.09.43-.24.43-.24,0,0-.33-.05-.71-.07l-.19-.21c.32-.01.55-.04.55-.04,0,0-.31-.17-.83-.26l-.43-.48h-1.45c.11-.09.08-.18.08-.18,0,0-.84-.07-1.32.02-.25.05-.42.1-.49.16h-.23s-.08-.03-.13-.04c-.45-.14-1.29-.15-1.29-.15,0,0-.05.09.05.2h-1.37",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.22,48.82c.38-.49.44-1.02,0-1.61-.68.23-1.06.59-1.15,1.07",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.53,55.78c.42,0,.42.7.37,1.48-.76-.04-1.22-.34-1.36-.94l-.49.74-.68-.54",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.29,50.68c.53-.17.6.19.68.54l-.49.74.31.67-.31.2",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75,21.7c0-7.9-6.1-14.3-6.1-14.3,0,0-6.1,6.4-6.1,14.3,0,11.4,2.73,14.3,6.1,14.3s6.1-3.57,6.1-14.3Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "76.65 43.32 76.65 28.17 74.62 23.23 74.62 17.28",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.18 24.43 79.15 28 78.68 31.4 76.81 33.28",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.02,
    y1: 26.3,
    x2: 77.28,
    y2: 22.21,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.03,21.7c0-7.9-6.1-14.3-6.1-14.3,0,0-6.1,6.4-6.1,14.3,0,11.4,2.73,14.3,6.1,14.3s6.1-3.57,6.1-14.3Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "165.93 43.32 165.93 28.17 163.9 23.23 163.9 17.28",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "170.47 24.43 168.43 28 167.96 31.4 166.09 33.28",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.31,
    y1: 26.3,
    x2: 166.56,
    y2: 22.21,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.04,21.7c0-7.9-6.1-14.3-6.1-14.3,0,0-6.1,6.4-6.1,14.3,0,11.4,2.73,14.3,6.1,14.3s6.1-3.57,6.1-14.3Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "94.94 43.32 94.94 28.17 92.91 23.23 92.91 17.28",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.48 24.43 97.45 28 96.98 31.4 95.1 33.28",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.32,
    y1: 26.3,
    x2: 95.57,
    y2: 22.21,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.06,
    y1: 43.4,
    x2: 121.06,
    y2: 22.81,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.02,
    y1: 22.47,
    x2: 123.01,
    y2: 22.47,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119.79,
    y1: 23.47,
    x2: 122.25,
    y2: 23.47,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.08,
    y1: 43.23,
    x2: 114.08,
    y2: 24.66,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.05,
    y1: 24.32,
    x2: 116.03,
    y2: 24.32,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.81,
    y1: 25.32,
    x2: 115.27,
    y2: 25.32,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.43,
    y1: 43.06,
    x2: 143.43,
    y2: 22.81,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.47,
    y1: 22.47,
    x2: 141.48,
    y2: 22.47,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.71,
    y1: 23.47,
    x2: 142.24,
    y2: 23.47,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.41,
    y1: 43.23,
    x2: 150.41,
    y2: 24.66,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.45,
    y1: 24.32,
    x2: 148.46,
    y2: 24.32,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.68,
    y1: 25.32,
    x2: 149.22,
    y2: 25.32,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "112.81 23.11 117.67 21.13 124.18 20.68 131.92 20.68",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "151.33 23.11 146.46 21.13 139.96 20.68 132.22 20.68",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.98,21.7c0-20.51,36.82-20.51,36.82,0",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.57,
    y1: 42.89,
    x2: 124.57,
    y2: 25.51,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.89,
    y1: 25.23,
    x2: 126.18,
    y2: 25.23,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.52,
    y1: 26.05,
    x2: 125.55,
    y2: 26.05,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.99,
    y1: 42.89,
    x2: 139.99,
    y2: 25.51,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.58
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.31,
    y1: 25.23,
    x2: 141.6,
    y2: 25.23,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.59
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.94,
    y1: 26.05,
    x2: 140.97,
    y2: 26.05,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.58
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "115.56 24.19 120.96 25.15 140.19 25.15 149.92 23.81",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.1,
    y1: 5.87,
    x2: 132.1,
    y2: 4.34,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.96
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadPop);
export default __webpack_public_path__ + "static/media/sad_pop.a1f0e3d373e17e6bcfaded7981627114.svg";
export { ForwardRef as ReactComponent };